enum LocalStorageKey {
    MODE = '_mode',
    API_SERVICE = '_apiService',
    THEME = '_theme',
    SYSTEM_NAME = '_systemName',
    API_VERSION = '_apiVersion',
    IS_OFFICE = '_isOffice',
    MIN_APP_VERSION = '_minAppVersion',
    APP_ENABLED = '_appEnabled',
    SERVER_TIMEZONE_OFFSET_MINUTES = '_serverTimezoneOffsetMinutes',
    USER_ID = '_userId',
    USERNAME = '_username',
    EMAIL = '_email',
    ACCESS = '_access',
    HASHED_PIN = '_uservalue', //"disguised" as uservalue to not draw unnecessary attention towards the hashed pin 
    LAST_ACTIVITY = '_lastActivity',
    TOKEN = '_token',
    REFRESH_TOKEN = '_refreshToken',
    EXPIRATION = '_expiration',
    TOKEN_TYPE = '_tokenType',
    TENANT_DISPLAY_NAME = '_tenantDisplayName',
}

export default LocalStorageKey;